module.exports = __webpack_public_path__ + "static/media/creativesHead.51387c46.jpg";